var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main-content" }, [
    _vm._m(0),
    _vm._v(" "),
    _vm.LoadingView === false
      ? _c("div", { staticClass: "card" }, [
          _c(
            "div",
            {
              staticClass: "card-header",
              class:
                _vm.purchase.state === 2
                  ? "bg-warning"
                  : _vm.purchase.state === 1
                  ? "bg-success"
                  : "bg-danger"
            },
            [_c("h5", [_vm._v("Compra: " + _vm._s(_vm.document))])]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "card-body" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-3" }, [
                  _c("label", { staticClass: "font-weight-bold" }, [
                    _vm._v("Fecha")
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(_vm._s(_vm.convertDate(_vm.purchase.purchase_date)))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-3" }, [
                  _c("label", { staticClass: "font-weight-bold" }, [
                    _vm._v("Fecha de entrega")
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(_vm._s(_vm.convertDate(_vm.purchase.delivery_date)))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-3" }, [
                  _c("label", { staticClass: "font-weight-bold" }, [
                    _vm._v("Localidad")
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(_vm.place.name))])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-3" }, [
                  _c("label", { staticClass: "font-weight-bold" }, [
                    _vm._v("Proveedor")
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      _vm._s(_vm.provider.nit) +
                        " | " +
                        _vm._s(_vm.provider.company)
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-3" }, [
                  _c("label", { staticClass: "font-weight-bold" }, [
                    _vm._v("Comprador")
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(_vm.buyer.name))])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-3" },
                  [
                    _c("label", { staticClass: "font-weight-bold" }, [
                      _vm._v("Estado")
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    [
                      _vm.purchase.state === 0
                        ? _c("span", { staticClass: "btn btn-danger btn-sm" }, [
                            _vm._v("Anulado")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.purchase.state === 2
                        ? _c(
                            "span",
                            { staticClass: "btn btn-warning btn-sm" },
                            [_vm._v("Pendiente")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.purchase.state === 1
                        ? _c(
                            "span",
                            { staticClass: "btn btn-success btn-sm" },
                            [_vm._v("Comprobado")]
                          )
                        : _vm._e()
                    ]
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "card-body" }, [
                  _c("table", { staticClass: "table" }, [
                    _vm._m(1),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.purchases, function(item) {
                        return _c("tr", { key: item.id }, [
                          _c("td", [_vm._v(_vm._s(item.code))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(item.nameProduct))]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(_vm._s(_vm.mymoney(item.purchase_price)))
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(_vm._s(_vm.myquantity(item.amount)))
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.mymoney(
                                  _vm.calculateSubtotal(
                                    item.purchase_price,
                                    item.amount
                                  )
                                )
                              )
                            )
                          ])
                        ])
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("tfoot", [
                      _c("tr", [
                        _vm._m(2),
                        _vm._v(" "),
                        _c("th", [
                          _c("h6", { staticClass: "font-weight-bold" }, [
                            _vm._v(_vm._s(_vm.mymoney(_vm.purchase.total)))
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.LoadingView === false
      ? _c("div", { staticClass: "card" }, [
          _vm._m(3),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "card-body" },
            _vm._l(_vm.payments, function(payment) {
              return _c(
                "div",
                { key: payment.id, staticClass: "row" },
                [
                  payment.namePayment === "Efectivo"
                    ? [
                        _c("div", { staticClass: "container" }, [
                          _c(
                            "div",
                            { staticClass: "row justify-content-center" },
                            [
                              _c("h5", { staticClass: "font-weight-bold" }, [
                                _vm._v(_vm._s(payment.namePayment))
                              ])
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("table", { staticClass: "table" }, [
                          _vm._m(4, true),
                          _vm._v(" "),
                          _c("tbody", [
                            _c("tr", [
                              _c("td", [
                                _vm._v(_vm._s(_vm.mymoney(payment.amount)))
                              ]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(payment.nameAccount))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(payment.description))])
                            ])
                          ])
                        ])
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  payment.namePayment === "Cheque"
                    ? [
                        _c("div", { staticClass: "container" }, [
                          _c(
                            "div",
                            { staticClass: "row justify-content-center" },
                            [
                              _c("h5", { staticClass: "font-weight-bold" }, [
                                _vm._v(_vm._s(payment.namePayment))
                              ])
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("table", { staticClass: "table table-dark" }, [
                          _vm._m(5, true),
                          _vm._v(" "),
                          _c("tbody", [
                            _c("tr", [
                              _c("td", [
                                _vm._v(_vm._s(_vm.mymoney(payment.amount)))
                              ]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(payment.nameAccount))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(payment.ChequeNumber))]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(payment.ChequeNameBank))
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  [
                                    payment.ChequeSameBank === "0"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "btn btn-danger btn-sm"
                                          },
                                          [_vm._v("No")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    payment.ChequeSameBank === "1"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "btn btn-success btn-sm"
                                          },
                                          [_vm._v("Si")]
                                        )
                                      : _vm._e()
                                  ]
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(payment.description))])
                            ])
                          ])
                        ])
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  payment.namePayment === "Depósito"
                    ? [
                        _c("div", { staticClass: "container" }, [
                          _c(
                            "div",
                            { staticClass: "row justify-content-center" },
                            [
                              _c("h5", { staticClass: "font-weight-bold" }, [
                                _vm._v(_vm._s(payment.namePayment))
                              ])
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("table", { staticClass: "table" }, [
                          _vm._m(6, true),
                          _vm._v(" "),
                          _c("tbody", [
                            _c("tr", [
                              _c("td", [
                                _vm._v(_vm._s(_vm.mymoney(payment.amount)))
                              ]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(payment.nameAccount))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(payment.DepositNumber))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(payment.description))])
                            ])
                          ])
                        ])
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  payment.namePayment === "Tarjeta de Crédito/Debito"
                    ? [
                        _c("div", { staticClass: "container" }, [
                          _c(
                            "div",
                            { staticClass: "row justify-content-center" },
                            [
                              _c("h5", { staticClass: "font-weight-bold" }, [
                                _vm._v(_vm._s(payment.namePayment))
                              ])
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("table", { staticClass: "table table-dark" }, [
                          _vm._m(7, true),
                          _vm._v(" "),
                          _c("tbody", [
                            _c("tr", [
                              _c("td", [
                                _vm._v(_vm._s(_vm.mymoney(payment.amount)))
                              ]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(payment.nameAccount))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(payment.CardNumber))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(payment.CardName))]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(payment.CardLast4digits))
                              ]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(payment.description))])
                            ])
                          ])
                        ])
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  payment.namePayment === "Transferencia"
                    ? [
                        _c("div", { staticClass: "container" }, [
                          _c(
                            "div",
                            { staticClass: "row justify-content-center" },
                            [
                              _c("h5", { staticClass: "font-weight-bold" }, [
                                _vm._v(_vm._s(payment.namePayment))
                              ])
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("table", { staticClass: "table" }, [
                          _vm._m(8, true),
                          _vm._v(" "),
                          _c("tbody", [
                            _c("tr", [
                              _c("td", [
                                _vm._v(_vm._s(_vm.mymoney(payment.amount)))
                              ]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(payment.nameAccount))]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(payment.TransferNumber))
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(payment.TransferNameBank))
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  [
                                    payment.TransferSameBank === "0"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "btn btn-danger btn-sm"
                                          },
                                          [_vm._v("No")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    payment.TransferSameBank === "1"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "btn btn-success btn-sm"
                                          },
                                          [_vm._v("Si")]
                                        )
                                      : _vm._e()
                                  ]
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(payment.description))])
                            ])
                          ])
                        ])
                      ]
                    : _vm._e()
                ],
                2
              )
            }),
            0
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.LoadingView === true
      ? _c(
          "div",
          { staticClass: "spinner-border", attrs: { role: "status" } },
          [_c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")])]
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("h3", { staticClass: "page-title" }, [_vm._v("Ver compra")]),
      _vm._v(" "),
      _c("ol", { staticClass: "breadcrumb" }, [
        _c("li", { staticClass: "breadcrumb-item" }, [
          _c("a", { attrs: { href: "#" } }, [_vm._v("Compra")])
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "breadcrumb-item active" }, [
          _vm._v("Ver combra")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Código")]),
        _vm._v(" "),
        _c("th", [_vm._v("Producto")]),
        _vm._v(" "),
        _c("th", [_vm._v("Precio")]),
        _vm._v(" "),
        _c("th", [_vm._v("Cantidad")]),
        _vm._v(" "),
        _c("th", [_vm._v("Descuento")]),
        _vm._v(" "),
        _c("th", [_vm._v("Subtotal")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", { staticClass: "text-right", attrs: { colspan: "5" } }, [
      _c("h6", { staticClass: "font-weight-bold" }, [_vm._v("Total")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header bg-primary" }, [
      _c("h5", [_vm._v("Pagos")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("td", [_vm._v("Monto")]),
        _vm._v(" "),
        _c("td", [_vm._v("Cuenta")]),
        _vm._v(" "),
        _c("td", [_vm._v("Descripción")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("td", [_vm._v("Monto")]),
        _vm._v(" "),
        _c("td", [_vm._v("Cuenta")]),
        _vm._v(" "),
        _c("td", [_vm._v("No.Cheque")]),
        _vm._v(" "),
        _c("td", [_vm._v("Banco")]),
        _vm._v(" "),
        _c("td", [_vm._v("Mismo banco")]),
        _vm._v(" "),
        _c("td", [_vm._v("Descripción")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("td", [_vm._v("Monto")]),
        _vm._v(" "),
        _c("td", [_vm._v("Cuenta")]),
        _vm._v(" "),
        _c("td", [_vm._v("No.Depósito")]),
        _vm._v(" "),
        _c("td", [_vm._v("Descripción")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("td", [_vm._v("Monto")]),
        _vm._v(" "),
        _c("td", [_vm._v("Cuenta")]),
        _vm._v(" "),
        _c("td", [_vm._v("No.Transacción")]),
        _vm._v(" "),
        _c("td", [_vm._v("Nombre de tarjeta")]),
        _vm._v(" "),
        _c("td", [_vm._v("Ultimos 4 dígitos de la tarjeta")]),
        _vm._v(" "),
        _c("td", [_vm._v("Descripción")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("td", [_vm._v("Monto")]),
        _vm._v(" "),
        _c("td", [_vm._v("Cuenta")]),
        _vm._v(" "),
        _c("td", [_vm._v("No.Transferencia")]),
        _vm._v(" "),
        _c("td", [_vm._v("Banco")]),
        _vm._v(" "),
        _c("td", [_vm._v("Mismo banco")]),
        _vm._v(" "),
        _c("td", [_vm._v("Descripción")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d78f3376", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d78f3376","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/views/admin/purchase/ViewPurchase.vue
// module id = 705
// module chunks = 0